import { Controller } from '@hotwired/stimulus'

// Pricing — sticky bottom CTA band (T1.10).
//
// Slides up after the user scrolls past the hero, hides over the
// FAQ / footer so it doesn't compete with form CTAs. Dismissable
// for the rest of the session.
//
// Markup contract:
//   <aside data-controller="pricing-stickycta">
//     ... <button data-action="click->pricing-stickycta#dismiss"> ...
//   </aside>
export default class extends Controller {
  connect() {
    this._dismissed = false
    try {
      this._dismissed = sessionStorage.getItem('mkt-stickycta-dismissed') === '1'
    } catch (_) {}
    if (this._dismissed) return

    this._heroH1 = document.getElementById('hero-h1')
    this._footer = document.querySelector('.mkt-footer')

    this._update = this._update.bind(this)
    window.addEventListener('scroll', this._update, { passive: true })
    window.addEventListener('resize', this._update)
    this._update()
  }

  disconnect() {
    window.removeEventListener('scroll', this._update)
    window.removeEventListener('resize', this._update)
  }

  dismiss() {
    this._dismissed = true
    this.element.setAttribute('data-shown', 'false')
    try { sessionStorage.setItem('mkt-stickycta-dismissed', '1') } catch (_) {}
  }

  _update() {
    if (this._dismissed) return
    const pastHero = this._heroH1 && this._heroH1.getBoundingClientRect().bottom < 0
    const footerNear = this._footer && this._footer.getBoundingClientRect().top < window.innerHeight + 120
    const show = pastHero && !footerNear
    this.element.setAttribute('data-shown', show ? 'true' : 'false')
  }
}
